// zh-Hant — baseline. All existing hard-coded UI strings live here.
// If a key is missing in another locale, this is the fallback.

export default {
  // ─── App-level / nav ────────────────────────────────────────────────────
  'app.title':           'Finance',
  'app.loading':         '載入中...',
  'nav.dashboard':       'Dashboard',
  'nav.transactions':    '交易',
  'nav.budgets':         '預算',
  'nav.settings':        '設定',
  'bottomnav.aria':      '主要導航',
  'sidebar.aria':        '桌面導航',

  // ─── Top bar ────────────────────────────────────────────────────────────
  'topbar.theme':        '切換主題',

  // ─── Dashboard ──────────────────────────────────────────────────────────
  'dashboard.title':     'Dashboard',
  'dashboard.income':    '收入',
  'dashboard.expense':   '支出',
  'dashboard.net':       '淨值',
  'dashboard.networth': '淨資產',
  'dashboard.networthHelper': '總收入 − 總支出（全部時間）',
  'dashboard.networthPositive': '儲蓄緊',
  'dashboard.networthNegative': '赤字中',
  'dashboard.savings':   '儲蓄率',
  'dashboard.balance':   '結餘',
  'dashboard.vsLast':    '對比上月',
  'kpi.noComparison': '無上期數據',
  'dashboard.rangeLabel': '時段',
  'dashboard.rangeHint': '撳一下跳到當期 · 長按 / 右鍵切換日/月/年/5年',
  'dashboard.vsYesterday':'昨日',
  'dashboard.vsLastYear':'對比去年',
  'dashboard.range.day': '日',
  'dashboard.range.month':'月',
  'dashboard.range.year':'年',
  'dashboard.range.5y': '5年',
  'dashboard.prevPeriod':'上一期',
  'dashboard.nextPeriod':'下一期',
  'dashboard.allCats':   '全部',
  'dashboard.autoApplied':'自動記錄咗 {n} 筆固定交易',
  'dashboard.forecast.title': '未來 30 日現金流預測',
  'dashboard.forecast.subtitle': '根據你嘅固定交易規則,預測下個月嘅餘額走勢',
  'dashboard.forecast.todayBalance': '今日餘額',
  'dashboard.forecast.projection30d': '+30 日預計',
  'dashboard.forecast.delta': '對比今日',
  'dashboard.forecast.activeCount': '{n} 條生效中',
  'dashboard.forecast.income': '收入',
  'dashboard.forecast.expense': '支出',
  'dashboard.forecast.legend.balance': '預計餘額',
  'dashboard.forecast.legend.events': '收入 / 支出事件',
  'dashboard.forecast.empty.title': '暫時未有預測',
  'dashboard.forecast.empty.body': '設定固定交易之後,就可以睇到下個月嘅現金流預測。',
  'dashboard.forecast.empty.cta': '去設定固定交易 →',
  'dashboard.forecast.tooltip.balance': '餘額',
  'dashboard.forecast.tooltip.events': '{n} 個事件',

  // ─── Transactions ───────────────────────────────────────────────────────
  'tx.title':            '交易',
  'transactions.openFilters': '篩選',
  'transactions.filters': '篩選',
  'transactions.filterDrawerTitle': '篩選交易',
  'transactions.typeLabel': '類型',
  'transactions.categoryLabel': '類別',
  'transactions.searchLabel': '搜尋',
  'transactions.removeFilter': '移除篩選：{name}',
  'transactions.resetFilters': '重設',
  'transactions.applyFilters': '套用',
  'transactions.cardsTitle': '信用咭',
  'transactions.cardFilterActive': '已啟用篩選',
  'transactions.filterByCard': '只睇{name}嘅交易',
  'transactions.unfilterCard': '顯示全部卡（清除篩選）',
  'transactions.noCardMatch': '呢段時間冇呢張卡嘅交易',
  'tx.search':           '搜尋備註或類別',
  'tx.empty':            '未有交易',
  'tx.emptyHint': '撳下面按鈕新增第一筆',
  'tx.thisMonth':        '本月',
  'tx.lastMonth':        '上月',
  'tx.last30':           '近30日',
  'tx.ytd':              '本年',
  'tx.all':              '全部',
  'tx.expense':          '支出',
  'tx.income':           '收入',
  'tx.allPeriod':        '全期',
  'tx.allCats':          '全部類別',
  'tx.tagLabel':         '標籤:',
  'tx.edit':             '編輯',
  'tx.delete':           '刪除',
  'tx.deleteConfirm':    '確定刪除呢筆交易?',
  // Phase 78: bulk-select mode
  'tx.bulkSelected':     '已選 {n} 筆',
  'tx.bulkCancel':       '取消',
  'tx.bulkSelectAll':    '全選',
  'tx.bulkClear':        '清除選取',
  'tx.bulkDeleteConfirm':'確定刪除已選嘅 {n} 筆交易?',
  'tx.bulkDeleted':      '已刪除 {n} 筆交易',
  // Phase 111: recurring badge
  'tx.recurring':        '固定',

  // ─── Add Transaction ────────────────────────────────────────────────────
  'add.newTitle':        '新增交易',
  'add.editTitle':       '編輯交易',
  'add.expense':         '支出',
  'add.income':          '收入',
  'add.amount':          '金額',
  'add.category':        '類別',
  'add.date':            '日期',
  'add.note':            '備註',
  'add.notePlaceholder': '可選',
  // Phase 80: mode-toggle buttons inside the add modal. The first
  // switches between regular 支出/收入 (add) vs 轉帳 (transfer).
  'add.modeAdd':         '新增',
  'add.modeTransfer':    '轉帳',
  // Phase 80: single merged payment-method picker replaces the
  // previous separate account + credit-card dropdowns.
  'add.paymentMethod':   '支付方式',
  'add.tags':            '標籤',
  'add.tagsPlaceholder': '用逗號分隔',
  'add.card':            '信用卡',
  'add.cardNone':        '不適用',
  'add.today':           '今日',
  // Phase 203: quick date chips in the Add Transaction form.
  'add.yesterday':       '昨日',
  'add.dayBefore':       '前天',
  // Phase 186 (M-113): 進階選項手風琴 (收埋 tag/note/bulk)。
  'add.advanced':        '進階選項',
  // Phase 189 (M-116): pager 控制 (上/下一頁箭嘴 + 圓點指示)。
  'addCategoryPager.prev': '上一頁',
  'addCategoryPager.next': '下一頁',
  'addCategoryPager.pageIndicator': '第 {n}/{total} 頁',
  // Phase 189 (M-116): AddCategoryModal 抽屜 labels。
  'addCategory.title':          '新增類別',
  'addCategory.newCategory':    '＋ 新增類別',
  'addCategory.nameLabel':      '名稱',
  'addCategory.namePlaceholder':'例如：咖啡基金',
  'addCategory.iconLabel':      '圖示',
  'addCategory.colorLabel':     '顏色',
  // Phase 49: bulk apply to date range
  'bulk.applyToRange':   '套用至日期範圍',
  'bulk.endDate':        '結束日期',
  'bulk.dayOfWeek':      '星期',
  'bulk.weekdayShort':   ['日', '一', '二', '三', '四', '五', '六'],
  'bulk.presetWeekdays': '平日 (一至五)',
  'bulk.presetEveryDay': '每日',
  'bulk.presetMWF':      '一/三/五',
  'bulk.preview':        '將會新增 {count} 筆交易',
  'bulk.emptyRange':     '範圍無符合條件嘅日期',
  'add.cancel':          '取消',
  'add.save':            '儲存',
  'add.saved':           '儲存成功',
  'add.failed':          '儲存失敗: {msg}',

  // ─── Budgets ────────────────────────────────────────────────────────────
  'budgets.title':       '預算',
  'budgets.empty':       '未設定預算',
  'budgets.emptyHint':   '喺每個類別揀「設定上限」就會儲低',
  'budgets.setLimit':    '設定上限',
  'budgets.used':        '已用',
  'budgets.of':          '/',
  'budgets.overBudget':  '超出預算!',
  'budgets.heroTotal':   '本月總預算',
  'budgets.heroRemaining': '剩餘 {amount}',
  'budgets.heroOverBy':  '超出 {amount}',
  'budgets.heroNoBudgets': '本月尚未設定預算',
  'budgets.heroNoBudgetsHint': '喺類別設定上限就會開始追蹤',
  'budgets.heroPctAria': '本月總預算已用 {pct}',

  // ─── Savings Goals (Phase 48) ────────────────────────────────────────
  'goals.title':                  '儲蓄目標',
  'goals.widgetTitle':            '儲蓄目標 ({n})',
  'goals.widgetEmpty':            '設定目標睇到自己嘅進度',
  'goals.summary':                '目標總覽',
  'goals.summaryPctAria':         '總體進度 {pct}',
  'goals.empty':                  '尚未設定儲蓄目標',
  'goals.emptyHint':              '設定一個目標開始追蹤儲蓄進度',
  'goals.addGoal':                '新增目標',
  'goals.editGoal':               '編輯目標',
  'goals.deleteGoal':             '刪除目標',
  'goals.deleteConfirm':          '刪除目標「{name}」?',
  'goals.field.name':             '目標名稱',
  'goals.field.target':           '目標金額',
  'goals.field.current':          '目前已儲',
  'goals.field.deadline':         '目標日期',
  'goals.field.trackingFrom':     '由 (淨儲蓄)',
  'goals.field.icon':             '圖示',
  'goals.field.color':            '顏色',
  'goals.field.allocationPct':    '每月分配 (%)',
  'goals.field.active':           '啟用',
  'goals.paused':                 '暫停',
  'goals.activeOn':               '啟用中',
  'goals.activeOff':              '已暫停',
  'goals.pctSumUnder':           '現時合計 {sum}% (< 100 OK, 剩餘會 untracked)',
  'goals.pctSumOver':            '現時合計 {sum}% (> 100 唔可以儲)',
  'goals.allocationHint':         '每月 {pct}% 儲蓄 · 預計 {months} 個月',
  'goals.mode.auto':              '自動',
  'goals.mode.manual':            '手動',
  'goals.eta':                    '預計 {days} 日達標',
  'goals.etaMonths':              '預計 {months} 個月達標',
  'goals.etaDate':                '預計 {date} 達標',
  'goals.etaNoHistory':           '—',
  'goals.completed':              '已達標',
  'goals.completedOver':          '已超標 +{amount}',
  'goals.progressAria':           '{name} 已儲 {pct}',
  'goals.overrides':              '預填金額',
  'goals.section':                '儲蓄目標 ({count})',  'accounts.title': '帳戶及錢包',
  'transfer.title': '轉帳',
  'accounts.widgetTotal': '所有帳戶合計',
  'accounts.widgetEmpty': '尚未新增帳戶',
  'chart.viewAsChart': '查看圖表',
  'chart.close': '關閉圖表',
  'transfer.mode': '轉帳模式',
  'transfer.from': '從帳戶',
  'transfer.to': '到帳戶',
  'transfer.sameAccount': '來源與目標帳戶必須不同',
  'transfer.success': '轉帳已記錄',
  'transfer.filter': '只顯示轉帳',
  'transfer.tag': 'transfer',
  // Phase 203: specific transfer validation errors. Before, every
  // failure showed 'transfer.sameAccount' — so "pick a destination
  // account" was reported as "source and destination must differ".
  'transfer.errMissingFrom':     '請選擇轉出帳戶',
  'transfer.errMissingTo':       '請選擇轉入帳戶',
  'transfer.errInvalidAmount':   '請輸入大於零的金額',
  'transfer.errAccountMissing':  '該帳戶已不存在',
  'transfer.noAccountsHint':     '請先在設定新增帳戶，才可記錄轉帳',
  'accounts.label': '帳戶',
  'accounts.add': '新增帳戶',
  'accounts.all': '全部帳戶',
  'accounts.defaultName': '現金',


  // ─── Settings ───────────────────────────────────────────────────────────
  'settings.title':      '設定',
  'settings.subnavLabel': '設定分區',
  'settings.subnavCurrency': '貨幣',
  'settings.subnavCards': '信用卡',
  'settings.subnavRecurring': '週期',
  'settings.subnavCategories': '類別',
  'settings.subnavGoals': '目標',
  'settings.subnavData': '資料',
  'settings.subnavAbout': '關於',
  'settings.section.cash':           '現金',
  'settings.section.cards':          '信用卡 ({n})',
  'settings.section.recurring':      '固定每月收入/支出 ({n})',
  'settings.section.expenseCats':    '支出類別 ({n})',
  'settings.section.incomeCats':     '收入類別 ({n})',
  'settings.section.sync':           'Google 同步',
  'settings.section.data':           '資料',
  'settings.section.currency':       '貨幣',
  'settings.section.appearance':     '外觀',
  'settings.section.about':          '關於',
  'settings.section.language':       '語言',                  // NEW

  'settings.language.label':     '介面語言',
  // Phase 81: shortened reassurance copy. Original mentioned data
  // retention which was obvious; the new copy focuses on instant
  // application.
  'settings.language.help':      '切換後即時生效',

  'settings.appearance.dark':    '深色模式',
  'settings.appearance.compact': '緊密版面',

  'settings.about.storage':      '資料儲存: 本機 SQLite ({path})',
  'settings.about.localOnly':    '所有資料留喺你部機，唔上雲。',
  'settings.about.title':        '關於',
  'settings.cardName':           '卡名',
  'settings.cardNamePlaceholder': '例: 匯豐白金卡',
  'settings.dueDay':             '到期日',
  'settings.outstandingAmount':  '未付金額',
  'settings.symbolExists':       '呢個符號已經存在',
  'settings.addSymbolFailed':    '加入失敗：{msg}',
  'settings.removeSymbolConfirm':'移除符號「{symbol}」？',
  'settings.keepOneSymbol':      '至少保留一個符號',
  'settings.removeSymbolFailed': '移除失敗：{msg}',

  'settings.recurring.add':      '新增',
  'settings.recurring.edit':     '編輯',
  'settings.recurring.delete':   '刪除',
  'settings.recurring.monthly':  '每月 {n} 日',
  'settings.recurring.addTitle': '新增固定規則',
  'settings.recurring.editTitle':'編輯固定規則',
  'settings.recurring.type':     '類型',
  'settings.recurring.category': '類別',
  'settings.recurring.amount':   '金額',
  'settings.recurring.day':      '每月幾號',
  'settings.recurring.dayPlaceholder': '例: 1 (每月 1 號)',
  'settings.recurring.note':     '備註',
  'settings.recurring.notePlaceholder': '例: 月薪',
  'settings.recurring.from':     '開始月份',
  'settings.recurring.to':       '結束月份（選填）',
  'settings.recurring.autoApplied': '📌 已自動記錄咗 {n} 筆固定交易:\n{lines}',
  'settings.recurring.cancel':   '取消',
  'settings.recurring.save':     '儲存',
  'settings.recurring.deleteConfirm': '刪除呢條固定規則?',
  'settings.recurring.amountPlaceholder': '例: 30000',
  'settings.recurring.fromPlaceholder': '開始月份',
  'settings.recurring.toPlaceholder': '不限',
  'settings.recurring.period':   '{from} → {to}',

  'settings.category.name':      '名稱',
  'settings.category.type':      '類型',
  'settings.category.icon':      '圖示',
  'settings.category.color':     '顏色',
  'settings.category.addNew':    '新增類別',
  'settings.category.editOne':   '編輯類別',
  'settings.category.cancel':    '取消',
  'settings.category.save':      '儲存',
  'settings.category.nameRequired':'請輸入名稱',
  'settings.category.deleteConfirm':'刪除類別「{name}」?',
  'settings.category.namePlaceholder': '例: 訂閱',
  'settings.category.expense': '支出',
  'settings.category.income': '收入',
  'settings.category.colorAria': '顏色 {color}',
  // Phase 79f: defaults have a small badge + enable/disable toggle.
  'settings.category.defaultBadge': '預設',
  'settings.category.defaultHint':  '預設類別唔可以編輯或刪除 — 只可以啟用/停用',
  'settings.category.enable':       '啟用',
  'settings.category.disable':      '停用',

  // ─── Common ─────────────────────────────────────────────────────────────
  // Phase 96: B-12 missing i18n keys. 4 common.* keys + cardDetail.paidOn
  // referenced by code but missing from all 4 bundles — users saw the
  // raw key in the UI (raw-key fallback in i18n resolver).
  'common.back':         '返回',
  'common.cancel':       '取消',
  'common.save':         '儲存',
  'common.search':       '搜尋',
  'common.delete':       '刪除',
  'common.confirmDelete':'確認刪除?',
  'common.edit':         '編輯',
  'common.confirm':      '確認',
  'common.close':        '關閉',
  'common.failed':       '儲存失敗: {msg}',
  'common.failedDelete': '刪除失敗: {msg}',
  'common.deleteConfirm':'確定刪除?',
  'common.today':        '今日',
  'common.unknown':      '未命名',
  'common.optional':     '選填',
  'common.none':         '不限',

  // ─── Errors ─────────────────────────────────────────────────────────────
  'err.generic':         '出咗事: {msg}',

  // ─── Sign-in / Sync ─────────────────────────────────────────────────────
  'signin.title':        '連接 Google 帳戶',
  'signin.subtitle':     '資料會喺你部機同 Google Drive 之間同步',
  'signin.button':       '用 Google 登入',
  'signin.skip':         '稍後再算 (本機使用)',
  'signin.connected':    '已連接',
  'signin.disconnect':   '登出',

  // ─── Command palette ────────────────────────────────────────────────────
  'cmd.placeholder':     '搜尋指令、頁面或交易...',
  'cmd.section.pages':   '頁面',
  'cmd.section.actions': '指令',
  'cmd.section.recent':  '近期交易',
  'cmd.theme.toggle':    '切換主題',
  'cmd.theme.dark':      '深色模式',
  'cmd.theme.light':     '淺色模式',
  'cmd.lang.switch':     '切換語言',
  'cmd.shortcutHint':    '按 ⌘K / Ctrl K 開啟搜尋',

  // ─── Empty / placeholder ────────────────────────────────────────────────
  'placeholder.noData':  '未有資料',
  'placeholder.addFirst':'新增第一筆',

  'dashboard.refresh.refreshing': '⟳ 更新中…',
  'dashboard.refresh.release': '↓ 鬆開更新',
  'dashboard.kpi.incomeYear': '收入(年)',
  'dashboard.kpi.incomeDay': '收入(今日)',
  'dashboard.kpi.income5y': '收入(5年)',
  'dashboard.kpi.expenseYear': '支出(年)',
  'dashboard.kpi.expenseDay': '支出(今日)',
  'dashboard.kpi.expense5y': '支出(5年)',
  'dashboard.kpi.netYear': '淨值(年)',
  'dashboard.kpi.netDay': '淨值(今日)',
  'dashboard.kpi.net5y': '淨值(5年)',
  'dashboard.rangeLabel.year': '全年 12 個月',
  'dashboard.rangeLabel.week': '過去 7 日',
  'dashboard.rangeLabel.halfYear': '過去 6 個月',
  'dashboard.rangeLabel.fiveYear': '過去 5 年（60 個月）',
  'dashboard.filter.title': '篩選',
  'dashboard.filter.openFilters': '篩選',
  'dashboard.filter.typeLabel': '類型',
  'dashboard.filter.categoriesLabel': '類別',
  'dashboard.filter.amountLabel': '金額範圍',
  'dashboard.filter.amountMin': '最小',
  'dashboard.filter.amountMax': '最大',
  'dashboard.trend.yoyLabel': '對比 {ym}',
  'dashboard.trend.yoyIncome': '收入(去年)',
  'dashboard.trend.yoyExpense': '支出(去年)',
  'dashboard.trend.viewLabel': '走勢圖檢視',
  'dashboard.trend.viewTimeline': '時間軸',
  'dashboard.trend.viewByYear': '按年比較',
  'dashboard.trend.metricLabel': '指標',
  'dashboard.onlyShowing': '只顯示 {name}',
  'dashboard.autoAppliedFmt': '📌 自動記錄咗 {n} 筆固定交易',
  'dashboard.card.dueTodayTitle': '💳 {name} 今日到期',
  'dashboard.card.dueInDaysTitle': '💳 {name} {n} 日後到期',
  'dashboard.card.unpaidHint': '{amount} 未還 · 記得交卡數',
  'dashboard.card.graceSuffix': '（剩 {n} 日免息期）',
  'filter.all': '全部',
  'filter.thisMonth': '本月',
  'filter.lastMonth': '上月',
  'filter.thisYear': '本年',
  'filter.date': '日期',
  'filter.amount': '金額',
  'filter.sortByDate': '依日期排序',
  'filter.sortByAmount': '依金額排序',
  'filter.noMatches': '呢段時間冇交易',
  'dashboard.card.overdue': '已逾期 {n} 日 · {date}',
  'dashboard.card.paidOn': '已於 {date} 繳付',
  'dashboard.card.allPaid': '所有卡本週期已繳清',
  'dashboard.card.dueToday': '今日到期 · {date}',
  'dashboard.card.dueTomorrow': '明日到期 · {date}',
  'dashboard.card.dueInDaysFmt': '{n} 日後到期 · {date}',
  'placeholder.empty': '未有數據',
  'common.loadingDots': '載入中…',
  'dashboard.filtering': '只顯示 ',
  'common.clear': '清除',
  'dashboard.netWorthSummary': '收入 {income} · 支出 {expense}',
  'dashboard.categoryBreakdown': '類別分佈',
  'common.manage': '管理',
  'dashboard.cardReminder': '提醒交卡數',
  'dashboard.recentTransactions': '最近交易',
  'budgets.alerts': '預算警示',
  'tx.seeAll': '查看全部',
  'tx.prevMonth': '上一個月',
  'tx.nextMonth': '下一個月',
  'common.clearSearch': '清除搜尋',
  'tx.noSearchMatch': '冇符合「{q}」嘅交易',
  'add.dirtyConfirm': '放棄呢筆未儲存嘅資料?',
  // Phase 106 (M-36): first-transaction celebration banner.
  'add.firstTxCelebration': '🎉 第一筆記錄!記帳正式開始',
  'common.saving': '儲存中…',
  'add.noCardsHint': '尚未新增信用卡。去「設定」加一張。',
  'budgets.deleteConfirm': '清除此類別預算上限?',
  'budgets.clear': '清除',
  'budgets.description': '設定每月各類別上限,超支時 Dashboard 會提示。',
  'budgets.thisMonthUsage': '本月 {spent} / {limit}',
  'budgets.limitPlaceholder': '每月上限',
  'budgets.invalidAmount': '預算必須係正數',
  'settings.cardsTitle': '信用卡 ({count})',
  'settings.cardsEmpty': '尚未新增信用卡。撳「+ 新增」加入第一張。',
  'settings.editCard': '編輯信用卡',
  'settings.deleteCard': '刪除信用卡',
  'settings.newCard': '新增信用卡',
  'settings.recurringTitle': '固定每月收入/支出 ({count})',
  'settings.editRecurring': '編輯固定規則',
  'settings.deleteRecurring': '刪除固定規則',
  'settings.newRecurring': '新增固定規則',
  'settings.expenseCatsTitle': '支出類別 ({count})',
  'settings.incomeCatsTitle': '收入類別 ({count})',
  'settings.newCategory': '新增類別',
  'settings.editCategory': '編輯類別',
  'settings.deleteCategoryConfirm': '刪除類別「{name}」?',
  'settings.deleteRecurringConfirm': '刪除呢條固定規則?',
  'settings.deleteCardConfirm': '刪除呢張信用卡?',
  'signin.loadGoogleFailed': '無法載入 Google 登入: {msg}',
  'signin.tagline': '用 Google 帳號登入，所有資料只屬於你',
  'signin.googleNotConfigured': 'Google 登入未設定 (GOOGLE_CLIENT_ID 缺失)',
  'signin.signingIn': '登入中...',
  'cmd.newTx': '新增交易',
  'cmd.goTo': '前往',
  'appearance.theme': '主題',
  'appearance.light': '淺色',
  'appearance.dark': '深色',
  // Phase 81: replaced misleading "預設跟系統" hint with one that
  // accurately describes the two-option toggle.
  'appearance.themeHint': '選擇後即時生效',
  'appearance.notifications': '瀏覽器通知',
  'appearance.notifDenied': '通知權限被拒,請到瀏覽器設定開啟。',
  'appearance.notifLabel': '信用咭 grace period critical 時彈通知',
  // Phase 81: removed dev-environment copy ("Dev 環境限制 localhost …").
  'appearance.notifHint': '需要允許瀏覽器通知權限。',
  'recap.title': '本週回顧',
  'recap.expenseFmt': '本週共使咗 {amount}',
  'recap.topCategoryFmt': '最多:{category} {amount}',
  'recap.upVsLastWeek': '比上週多',
  'recap.downVsLastWeek': '比上週少',
  'appearance.weeklyRecap': '每週回顧通知',
  'appearance.weeklyRecapHint': '每週日提醒你本週使費。',
  'appearance.compactFilter': '簡化篩選列',
  'appearance.compactFilterHint': '隱藏類別篩選以節省頂部空間',
  // Phase 81: distinct section heading (was duplicating the toggle
  // label below).
  'appearance.compactFilterTitle': '交易頁篩選',
  'installments.title': '信用卡分期',
  'installments.add': '新增分期',
  'installments.empty': '尚未有分期記錄',
  'installments.total': '總金額',
  'installments.monthlyAmount': '每月還款',
  'installments.periods': '已還 {paid}/{total} 期',
  'installments.remaining': '還剩 {n} 期',
  'installments.nextPayment': '下次還款',
  'installments.complete': '已還完',
  'installments.markPaid': '標記本期已還',
  'installments.markEnded': '標記分期完成',
  'installments.note': '備註 (購買項目)',
  'installments.totalAmount': '總金額',
  'installments.totalPeriods': '期數',
  'installments.startMonth': '開始月份',
  'installments.card': '信用卡',
  'installments.future.title': '未來分期',
  'installments.future.subtitle': '共 {n} 期未還,合計 {total}',
  'installments.notify.title': '信用卡分期還款',
  'installments.notify.body': '{card} · {amount} · 第 {period}/{total} 期{note_sfx}',
  'installments.notify.noteSuffix': ' ({note})',
  'currency.title': '貨幣顯示',
  'currency.saveFailed': '設定失敗: {msg}',
  'currency.addFailed': '加入失敗: {msg}',
  'currency.keepOne': '至少保留一個 symbol',
  'currency.deleteSym': '刪除 {sym}',
  'currency.addAria': '加入新貨幣符號',
  'currency.preview': '現時顯示: {amount}',
  'data.title': '資料管理',
  'data.importHint': '由 CSV 檔匯入交易記錄',
  'data.importAria': '選擇 CSV 檔',
  'data.importColumns': '欄位順序: type, amount, category, occurred_on, note, tags',
  'data.importing': '匯入中…',
  'data.importOk': '成功 {imported} 筆,略過 {skipped} 筆',
  'data.importOkErrors': ' · {n} 個錯誤',
  'data.importFailed': '匯入失敗: {msg}',
  'data.exportHint': '下載所有交易為 CSV 檔案',
  'data.exportBtn': '匯出 CSV',
  'data.exporting': '匯出中…',
  'data.exportOk': '已匯出 {n} 筆交易',
  'data.exportFailed': '匯出失敗: {msg}',
  'data.clearHint': '刪除所有交易記錄(類別、預算、設定會保留)',
  'data.clearAll': '刪除所有交易',
  'data.clearConfirm': '確認清除所有交易?呢個操作無法復原。',
  'data.clearing': '刪除中…',
  'data.confirmClear': '確認刪除',
  'data.clearedN': '已刪除 {n} 筆交易',
  'data.clearFailed': '刪除失敗: {msg}',
  // Phase 47: redesigned DataSection visual hierarchy
  'data.dangerZone': '危險區域',
  'data.dangerZoneDesc': '這些操作無法復原,請謹慎使用。',
  'data.importDrop': '點擊或拖放 CSV 檔案到此處',
  'data.importDropHint': '支援 .csv 格式',
  'account.title': '帳號綁定',
  'account.subtitle': '同步至其他裝置。',
  'account.noName': '(無名稱)',
  'account.signOutConfirm': '確定登出?',
  'account.signOut': '登出',
  'account.saveFailed': '儲存失敗:{msg}',
  // Phase 46: local-vs-cloud 帳號 UI
  'account.localBadge': '本地帳號',
  'account.localDesc': '只儲存於此裝置。無備份、無同步。',
  'account.deleteLocal': '刪除本地帳號',
  'account.deleteLocalConfirm': '刪除此本地帳號?此裝置上所有資料將永久刪除。',
  'account.deleteLocalDone': '本地帳號已刪除',
  'account.connectGoogle': '綁定 Google 帳號',
  'account.connectGoogleDesc': '同步交易至其他裝置。',
  'account.googleComingSoon': '即將推出 — Phase B',
  'account.deleteLocalHint': '此操作無法復原。',
  // Phase 46b: bullet-style local-account description + new keys
  'account.connected': '已連接',
  'account.localBullet.device': '儲存於此裝置',
  'account.localBullet.noBackup': '無備份',
  'account.localBullet.noSync': '無同步',
  // Phase 40: developer card (local-only sample data)
  'developer.title': '開發者選項',
  'developer.version': 'App 版本',
  'developer.localOnly': '只係寫入此裝置嘅 IndexedDB,絕對唔會去到伺服器。',
  'developer.seed500': '產生 500 筆範例交易',
  'developer.seed100': '產生 100 筆範例交易',
  'developer.seed10y': '產生 1200 筆 / 10 年範例',
  'developer.seedConfirm': '幫此裝置插入 {n} 筆隨機範例交易（分佈於 {y} 年內）?',
  'developer.seedOk': '已插入 {n} 筆範例交易。',
  'developer.resetTx': '刪除此裝置所有交易',
  'developer.resetConfirm': '刪除此裝置嘅所有交易?呢個操作無得 undo。',
  'developer.resetOk': '已刪除 {n} 筆交易。',
  'developer.working': '處理中…',
  'developer.failed': '失敗: {msg}',
  'topbar.search': '全域搜尋',
  'topbar.searchTitle': '全域搜尋 (Cmd/Ctrl+K)',
  'topbar.themeLight': '切換淺色',
  'topbar.themeDark': '切換深色',
  'topbar.quickAdd': '新增交易',
  'topbar.filters': '切換篩選',
  'topbar.searchTip': '撳 / 或 Cmd+K 都得',
  'fab.newTx': '新增交易',
  'common.refresh.release': '↓ 鬆開更新',
  'common.refresh.refreshing': '⟳ 更新中…',
  'budgets.notSet': '未設定預算',
  'budgets.notSetHint': '去「預算」頁面設定每月上限',
  'budgets.budgetsCount': '個預算',
  'budgets.overCount': '個超支',
  'budgets.warnCount': '個接近',
  'budgets.over': '超支',
  'budgets.warn': '接近',
  'budgets.progressAria': '{name} 已用 {pct}',
  'tx.seeAllFmt': '查看全部 ({count})',
  'tx.emptyCta': '新增交易',
  'tx.listCountFmt': '顯示 {shown} / {total} 筆',
  'category.noExpense': '未有支出記錄',
  'settings.categoryNameRequired': '請輸入名稱',
  'settings.reorderFailed': '重新排序失敗: {msg}',
  'settings.moveUp': '向上移',
  'settings.moveDown': '向下移',
  'settings.reorder': '拖曳以重新排序',
  'settings.cardSettleConfirm': '確認已還款?本期累計會重設為 0。',
  'settings.cardSettleTitle': '確認已還款,重設本期累計',
  'settings.cardSettleFailed': '還款確認失敗: {msg}',
  'settings.cardStatementDue': '結單日 {stmt} · 到期日 {due}',
  'settings.cardDueToday': '今日到期',
  'settings.cardDueTomorrow': '明日到期',
  'settings.cardDueInDays': '{n} 日後到期',
  'settings.cardGraceRemaining': '剩 {n} 日免息期',
  'settings.cardOverdue': '已逾期 {n} 日',
  'settings.cardOutstanding': '本期累計 {amount}',
  'settings.cardSettle': '確認還款',
  'settings.cardPaid': '已還款',
  'settings.statementDay': '結單日',
  'settings.expiryMonth': '到期月份 (MM)',
  'settings.expiryYear': '到期年 (YY)',
  'settings.expiryMonthPlaceholder': '例: 8',
  'settings.expiryYearPlaceholder': '例: 27',
  'settings.expiryHint': '可留空。月年要一齊填。',
  'settings.recurringHint': '設定後,每次開 Dashboard 會自動記錄當月交易(用本地時間)。',
  'settings.category.editorHint': '輸入名稱、選擇類型，再選圖示及顏色。',
  'signin.appTitle': '記帳 App',
  'common.add': '新增',
  'common.all': '全部',
  'categories.餐飲': '餐飲',
  'categories.交通': '交通',
  'categories.水費': '水費',
  'categories.電費': '電費',
  'categories.煤氣': '煤氣',
  'categories.居家': '居家',
  'categories.投資': '投資',
  'categories.娛樂': '娛樂',
  'categories.購物': '購物',
  'categories.醫療': '醫療',
  'categories.稅務': '稅務',
  // Phase 82b: renamed from 交卡數 to 卡數.
  'categories.卡數': '卡數',
  'categories.其他': '其他',
  'categories.薪金': '薪金',
  'categories.投資回報': '投資回報',
  'categories.獎金': '獎金',
  'cmd.ariaLabel': '指令面板',
  'cmd.searchPlaceholder': '搜尋交易、類別、預算、固定、信用卡...',
  'cmd.loading': '載入中…',
  'cmd.noResults': '冇符合「{q}」嘅結果',
  'cmd.footerHint': '↑↓ 選擇 · ↵ 確認 · ESC 關閉',
  'cmd.toOpen': '開啟',
  'cmd.expenseCat': '支出類別',
  'cmd.incomeCat': '收入類別',
  'cmd.budget': '預算',
  'cmd.perMonth': '每月',
  'cmd.dayOfMonth': '日',
  'cmd.outstanding': '未還',
    'cardDetail.title': '信用卡交易',
    'cardDetail.empty': '呢張卡暫時未有交易記錄',
    'cardDetail.notFound': '揾唔到呢張卡',
    'cardDetail.outstanding': '尚欠金額',
    'cardDetail.nextDue': '到期日',
    'cardDetail.cycle': '帳單週期',
    'cardDetail.markPaid': '標記今日已繳',
    'cardDetail.transactions': '交易記錄',
    'cardDetail.addTagged': '新增交易',
    'cardDetail.openCard': '查看{name}嘅交易',
    'cardDetail.paidOn':   '已於 {date} 繳付',

    // Phase 102: First-time onboarding carousel.
    'onboard.step1.title':      '設定你嘅語言同貨幣',
    'onboard.step1.body':       '揀返你用開嘅語言同貨幣符號。可以之後喺設定更改。',
    'onboard.step1.langLabel':  '語言',
    'onboard.step1.curLabel':   '貨幣符號',
    'onboard.step1.preview':    '現時顯示',
    'onboard.step2.title':      '記錄你嘅第一筆',
    'onboard.step2.body':       '幾秒就可以記一筆,之後可以隨時加嘢、改嘢、刪嘢。',
    'onboard.step2.bullet1':    '選收支類型(支出/收入)',
    'onboard.step2.bullet2':    '打金額同揀類別',
    'onboard.step2.bullet3':    '儲存後即時喺主頁睇到',
    'onboard.step2.tipNote':    '提示:首次記帳會見到 3 個小貼士,可以逐個「知道了」收埋。',
    'onboard.step3.title':      '本地優先 + 雲端備份',
    'onboard.step3.body':       '你嘅資料儲存在裝置上,離線都用到。Google 登入後可跨裝置同步。',
    'onboard.step3.bullet1':    '本地儲存:快、離線可用',
    'onboard.step3.bullet2':    'Google 登入(可選):跨裝置同步',
    'onboard.step3.signinNote': '登入後會自動推送本地資料到雲端,毋須手動操作。',
    'onboard.back':             '返回',
    'onboard.next':             '下一步',
    'onboard.skip':             '跳過',
    'onboard.later':            '稍後再說',
    'onboard.logNow':           '立即記一筆',
    'onboard.start':            '開始使用',
    'onboard.tooltip.type':     '👆 開支同收入分開記,統計會更清楚。',
    'onboard.tooltip.amount':   '💰 金額可以用快速鍵盤輸入。',
    'onboard.tooltip.category': '🏷️ 揀類別方便之後睇趨勢。',
    'onboard.tooltip.gotIt':    '知道了',
    'onboard.replay.title':     '教學',
    'onboard.replay.body':      '重新行一次新手教學。',
    'onboard.replay.button':    '重新播放教學',

    // Phase 104: collapsible group titles + privacy mode.
    'settings.group.prefs':    '偏好 / Preferences',
    'settings.group.tracking': '記帳 / Tracking',
    'settings.group.data':     '資料 / Data',
    'settings.group.help':     '說明 / Help',
    'privacy.title':           '隱藏金額',
    'privacy.body':            '開啟後,Dashboard/交易/預算金額會隱藏,撳一下顯示 5 秒。',

    // Phase 103: Reset All Settings (destructive).
    'resetAll.title':         '初始化所有設定',
    'resetAll.body':          '清除所有本地資料:交易、帳戶、類別、預算、固定收支、信用卡、儲蓄目標、安裝分期、設定。伺服器上嘅資料會保留。清除後會重新彈出新手教學。',
    'resetAll.button':        '初始化所有設定',
    'resetAll.confirmTitle':  '確認要清除所有本地資料?',
    'resetAll.confirmBody':   '此操作無法復原。請輸入 {phrase} 以確認。',
    'resetAll.confirmLabel':  '輸入 DELETE',
    'resetAll.confirmButton': '永久清除',
    'resetAll.failed':        '初始化失敗:{msg}',

    // Phase 202d/202e: Sync section + destructive server wipe.
    // Previously these strings had no locale entries and fell back to
    // the inline defaultValue (zh-Hant copy) in EVERY language — so the
    // en/ja/zh-Hans users saw Chinese text in the Sync section.
    'settings.sync.title':                  '跨設備同步',
    'settings.sync.desc':                   '從 Google 帳號重新拉取所有資料到本機。新裝置或重灌後使用。',
    'settings.sync.button':                 '重新同步',
    'settings.sync.wipeButton':             '清空本機並重新同步',
    'settings.sync.wipeConfirmTitle':       '此操作會清除本機所有交易、類別、信用卡、定期、預算、目標、帳戶,然後重新從伺服器拉取。',
    'settings.sync.wipeConfirmWarn':        '尚未成功上傳到伺服器的本機資料會永久遺失。建議先按上方「重新同步」確認伺服器有資料,再執行此操作。',
    'settings.sync.wipeExecute':            '確認清空並重新同步',
    'settings.sync.wipeServerButton':       '清空伺服器資料並重新登入',
    'settings.sync.wipeServerConfirmTitle': '此操作會刪除伺服器上您帳號的所有交易、類別、信用卡、定期、預算、目標、設定,以及您的帳號記錄。',
    'settings.sync.wipeServerConfirmWarn':  '伺服器資料刪除後無法復原。完成後頁面會自動重新載入,您需要重新以 Google 帳號登入。',
    'settings.sync.wipeServerExecute':      '確認清空伺服器',
    'common.error':                         '發生錯誤',

  // Phase 208 / card 208-D1 — recurring-transaction reminders.
  'recurring.reminder.title': '提醒',
  'recurring.reminder.countFmt': '{count} 筆即將發生的固定交易',
  'recurring.reminder.itemFmt': '{category} · {amount} · {when}',
  'recurring.reminder.dueToday': '今日到期',
  'recurring.reminder.dueInDays': '{n} 天後到期',
  'recurring.reminder.appliedFmt': '{name} 已自動加入',
  'recurring.reminder.toggleLabel': '在記賬前提醒我',
  'recurring.reminder.leadLabel': '提前 {n} 天提醒我',
  'recurring.reminder.globalToggle': '固定交易提醒',
  'recurring.reminder.globalHint': '下次開啟 app 時會提示你,在固定收入／支出入賬前。',
};
